<div class="dropdown-input__wrapper">

	<div class="dropdown-input" (click)=INDRA_handleAddClick() tabindex=0 [attr.aria-label]="arialabel">
		<app-svg class="dropdown-select__icon" svg="icons.svg#{{icon.svg}}" aria-hidden="true" [alt]="icon.label"></app-svg>
		<div class="dropdown-select__text" aria-hidden="true">
			<span class="dropdown-select__label">{{ label }} </span>
			<span class="dropdown-select__count">{{ INDRA_printCount() }}</span>
		</div>
		<span class="link">Add</span>
	</div>


	<div class="dropdown-items" [formGroup]="group" *ngIf="showDropdown">
		<app-counter-input *ngFor="let item of items" 
		[formControlName]="item.type" 
		[passengerType] = "item.type"
		[min]="item.min" 
		[max]="item.max" 
		[label]="item.label" 
		[description]="item.description"
		[setIncrementToDisable]="setIncrementToDisable" 
		[setDecrementToDisable]="setDecrementToDisable">
	</app-counter-input>
	</div>
</div>
